import type { TOC } from '@ember/component/template-only';
import { assert } from '@ember/debug';
import { concat } from '@ember/helper';
import { trustHTML } from '@ember/template';
import { ILLUSTRATIONS_MAP } from '@mylighthouse/prism-foundation';

import type {
  IllustrationName,
  IllustrationSize,
} from '../../types/components/prism/illustration.ts';

export const ILLUSTRATION_SIZE_MAP: Record<
  Exclude<IllustrationSize, 'unsafe_unconstrained'>,
  string
> = {
  small: 'prism-illustration--small',
  medium: 'prism-illustration--medium',
  large: 'prism-illustration--large',
};

function getClassForSize(size: IllustrationSize): string {
  if (size === 'unsafe_unconstrained') {
    return '';
  }

  return ILLUSTRATION_SIZE_MAP[size];
}

function getSvgCode(name: IllustrationName): string {
  const svgCode = ILLUSTRATIONS_MAP[name];

  assert(`Illustration "${name}" does not exist`, svgCode);

  return svgCode;
}

interface PrismIllustrationSignature {
  Args: {
    name: IllustrationName;
    size: IllustrationSize;
  };
  Element: HTMLDivElement;
}

const PrismIllustration: TOC<PrismIllustrationSignature> = <template>
  <div
    class={{concat "prism-illustration" " " (getClassForSize @size)}}
    data-test-illustration={{@name}}
    ...attributes
  >
    {{trustHTML (getSvgCode @name)}}
  </div>
</template>;

export default PrismIllustration;

export type { IllustrationName };
